export default 'quizResults'
